import { Routes } from '@angular/router';
import { DEPOSIT_CONFIG } from './base/deposit-config';

export const depositRoutes: Routes = [
  {
    path: DEPOSIT_CONFIG.routePath!,
    data: { title: '입금 관리' },
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
      },
      {
        path: 'list',
        loadComponent: () =>
          import(
            './components/smart/deposit-list-page/deposit-list-page.component'
          ).then((m) => m.DepositListPageComponent),
        children: [
          {
            path: ':id',
            loadComponent: () =>
              import(
                './components/smart/deposit-detail-page/deposit-detail-page.component'
              ).then((m) => m.DepositDetailPageComponent),
            data: { title: '입금 상세' },
          },
        ],
      },
    ],
  },
];
